import { siteInfo, footerInfo } from '@/mocks/homeData';

export default function Footer() {
  return (
    <footer id="footer" className="bg-background-950 text-background-50">
      <div className="w-full px-4 md:px-6 py-14 md:py-16 max-w-[1400px] mx-auto">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <span className="text-xl font-display text-primary-400 tracking-wide">{siteInfo.siteName}</span>
            <p className="mt-4 text-sm text-background-300 leading-relaxed">
              {footerInfo.description}
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-100 mb-4">快速导航</h4>
            <ul className="space-y-2">
              {footerInfo.sections.quickLinks.map((link) => (
                <li key={link.href}>
                  <a href={link.href} className="text-sm text-background-300 hover:text-primary-400 transition-colors cursor-pointer">
                    {link.text}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-100 mb-4">热门赛道</h4>
            <ul className="space-y-2">
              {footerInfo.sections.tracks.map((link) => (
                <li key={link.href}>
                  <a href={link.href} className="text-sm text-background-300 hover:text-primary-400 transition-colors cursor-pointer">
                    {link.text}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-100 mb-4">合作伙伴</h4>
            <p className="text-sm text-background-400">合作品牌与媒体伙伴陆续入驻中，敬请期待。</p>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-background-800/50 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background-500">© 2026 {siteInfo.siteName}. All rights reserved.</p>
          <p className="text-xs text-background-500">内容仅供娱乐参考，不构成任何投资或法律建议</p>
        </div>
      </div>
    </footer>
  );
}